import {
  action,
  observable,
  runInAction,
  makeObservable,
  computed,
} from "mobx";
import React from "react";
import { Empty, MenuProps } from "antd";
import api from "../../api";
import { HomeOutlined } from "@ant-design/icons";
import router from "../../router";

type MenuItem = Required<MenuProps>["items"][number];

class CommonStore {
  @observable MenuRouter: any = [];
  @observable permissionMenuRouter: any = [];
  @observable menuList: any = [];
  @observable pagePermission: any = {};
  @observable personalContent: boolean = false;
  //面包屑
  @observable breadcrumbTitle: any = [];
  @observable permissionbreadcrumbTitle: any = [];
  //用户登录信息
  @observable userInfo: userInfoData = {
    isAdmin:false,
    customerDisplayName:'',
    account: "",
    userId: 0,
    organization: null,
    menuResourcelist: [],
    loginType: "",
    authorities: [],
    phoneNumber: "",
    attributes: null,
    accountDisplayName: "",
    organizationDisplayName: "",
    organizationNo: "",
  };
  @observable managementResource: string = "";
  @observable showMore: any = false; //高级搜索
  @observable targetPlatformList: Array<any> = []; //平台编码
  @observable homePageDataList: any = {}; //获取门户平台首页展示数据
  @observable apool: any = {};
  @observable xpool: any = {};

  constructor() {
    makeObservable(this);
  }

  getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: string
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }

  //根据权限生成路由
  getMenu(menuItem: menuItem[]) {
    let AuthorizedMenu: any = [];
    AuthorizedMenu = menuItem.map((value: any) => {
      if (value.children) {
        const childrenMenu = this.getMenu(value.children);
        return childrenMenu
          ? this.getItem(
              value.meta.title,
              value.path,
              value.meta.icon,
              childrenMenu,
              value.meta.key ? value.meta.key : ""
            )
          : null;
      } else {
        if (
          value.meta &&
          value.meta.key &&
          this.menuList &&
          this.menuList.indexOf(value.meta.key) !== -1
        ) {
          return this.getItem(
            value.meta.title,
            value.path,
            value.meta.icon,
            value.children ? this.getMenu(value.children) : null,
            value.meta.key ? value.meta.key : ""
          );
        }
        return null;
      }
    });
    AuthorizedMenu = AuthorizedMenu.filter((item: any) => item);
    if (AuthorizedMenu.length > 0) {
      return AuthorizedMenu;
    }
  }

  //根据权限生成生成权限页面路由
  permissiongetMenu(menuItem: menuItem[]) {
    let AuthorizedMenu: any = [];
    AuthorizedMenu = menuItem.map((value: any) => {
      if (value.children) {
        const childrenMenu = this.getMenu(value.children);
        return childrenMenu
          ? this.getItem(
              value.meta.title,
              value.path,
              null,
              childrenMenu,
              value.meta.key ? value.meta.key : ""
            )
          : null;
      } else {
        if (
          value.meta &&
          value.meta.key &&
          this.menuList &&
          this.menuList.indexOf(value.meta.key) !== -1
        ) {
          return this.getItem(
            value.meta.title,
            value.path,
            null,
            value.children ? this.getMenu(value.children) : null,
            value.meta.key ? value.meta.key : ""
          );
        }
        return null;
      }
    });
    AuthorizedMenu = AuthorizedMenu.filter((item: any) => item);
    if (AuthorizedMenu.length > 0) {
      return AuthorizedMenu;
    }
  }
  //获取权限修改页面完整的侧边栏
  @computed
  get permissionnewMenuRouter(): Array<MenuItem> {
    const routeMenu = this.permissiongetMenu(router.AUTH_ROURE);
    let completeMenu: Array<MenuItem> = routeMenu ? routeMenu : [];
    runInAction(() => {
      this.permissionMenuRouter = completeMenu;
    });
    return completeMenu;
  }

  //获取完整的侧边栏
  @computed
  get newMenuRouter(): Array<MenuItem> {
    const routeMenu = this.getMenu(router.AUTH_ROURE);
    let completeMenu: Array<MenuItem> = routeMenu ? routeMenu : [];
    runInAction(() => {
      this.MenuRouter = completeMenu;
    });
    completeMenu.unshift(this.getItem("首页", "/home", <HomeOutlined />));
    return completeMenu;
  }

  //传递sso登录信息
  ssoLoginCode(url: string, state: string) {
    const data = { url: url, state: state };
    api.loginApi
      .ssologin(data)
      .then((res) => {
        this.loginUserInfo("loginFlag");
      })
      .catch((e: any) => {});
  }

  //获取用户登录信息
  async loginUserInfo(loginFlag?: string) {
    try {
      let res = await api.loginApi.loginUserInfo();
      if (res) {
        runInAction(() => {
          this.userInfo = res.data;
        });
        if (loginFlag) {
          window.location.href = `${window.location.origin}/#/chooseCompany`;
          setTimeout(() => {
            alert("请您重新登录");
            this.toLogOut();
          }, 600000);
        }
      }
    } catch (e) {}
  }

  //获取菜单展示列表
  @action
  async getMenuList() {
    await api.loginApi
      .menuList()
      .then((res: any) => {
        runInAction(() => {
          this.menuList = res.data;
        });
      })
      .catch((e: any) => {
        window.location.href = `${window.location.origin}/#/login`;
      });
  }

  //退出登录
  @action
  async toLogOut(flag?: any) {
    try {
      // window.location.hash = "#/login";
      window.location.href = `${window.location.origin}/#/login`;
      if (flag !== "401") {
        // await api.loginApi.logout();
        window.location.href = `${window.location.origin}/api/logout`;
      }
    } catch (error) {
      console.log(error);
    }
  }

  findKey = (router: any, keys: string) => {
    router.find((item: any) => {
      if (item.key == keys) {
        this.managementResource = item.type;
      } else if (item.children) {
        this.findKey(item.children, keys);
      }
    });
  };

  //修改权限页面面包屑
  @action
  permissionBreadcrumbData() {
    let newBreadcrumb: Array<{ title: string }> = [];
    this.permissionnewMenuRouter.forEach((oneLevel: any) => {
      if (oneLevel.type === this.managementResource) {
        newBreadcrumb.push({ title: oneLevel.label });
        return;
      }
      oneLevel.children &&
        oneLevel.children.forEach((secondLevel: any) => {
          if (secondLevel.type === this.managementResource) {
            newBreadcrumb.push({ title: oneLevel.label });
            newBreadcrumb.push({ title: secondLevel.label });
            return;
          }
          secondLevel.children &&
            secondLevel.children.forEach((threeLevel: any) => {
              if (threeLevel.type === this.managementResource) {
                newBreadcrumb.push({ title: oneLevel.label });
                newBreadcrumb.push({ title: secondLevel.label });
                newBreadcrumb.push({ title: threeLevel.label });
              }
            });
        });
    });
    runInAction(() => {
      this.permissionbreadcrumbTitle = [...newBreadcrumb];
    });
  }

  @action
  getPagePermission(managementResource: any) {
    api.userPermissionApi
      .getPagePermission(managementResource)
      .then((res: any) => {
        runInAction(() => {
          this.pagePermission = res.data;
        });
      })
      .catch((e: any) => {});
  }

  //修改面包屑
  @action
  changeBreadcrumb(arr: any, key: string) {
    let newBreadcrumb: Array<{ title: string }> = [];
    arr.forEach((oneLevel: any) => {
      if (oneLevel.key === key) {
        newBreadcrumb.push({ title: oneLevel.label });
        return;
      }
      oneLevel.children &&
        oneLevel.children.forEach((secondLevel: any) => {
          if (secondLevel.key === key) {
            newBreadcrumb.push({ title: oneLevel.label });
            newBreadcrumb.push({ title: secondLevel.label });
            return;
          }
          secondLevel.children &&
            secondLevel.children.forEach((threeLevel: any) => {
              if (threeLevel.key === key) {
                newBreadcrumb.push({ title: oneLevel.label });
                newBreadcrumb.push({ title: secondLevel.label });
                newBreadcrumb.push({ title: threeLevel.label });
              }
            });
        });
    });
    runInAction(() => {
      this.breadcrumbTitle = [...newBreadcrumb];
    });
  }

  @action
  async personal() {
    runInAction(() => {
      this.personalContent = !this.personalContent;
    });
  }

  advancedSearch() {
    runInAction(() => {
      this.showMore = !this.showMore;
    });
  }

  @action
  getPlatformCode() {
    api.loginApi
      .getByType("portalPlatformCode")
      .then((res: any) => {
        if (res.code == 200) {
          runInAction(() => {
            this.targetPlatformList = res.data;
          });
        }
      })
      .catch((e) => {});
  }

  //获取门户平台首页展示数据
  @action
  async getHomePageData() {
    await api.loginApi
      .getHomePageData()
      .then((res: any) => {
        runInAction(() => {
          this.homePageDataList = res.data;
          this.apool = {
            title: {
              text: "A号数量",
            },
            tooltip: { trigger: "axis" },
            legend: {
              data: ["已上架", "待上架", "已禁用"],
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: {
              type: "category",
              boundaryGap: false,
              data: res.data.poolInfo.timestampList,
            },
            yAxis: { type: "value" },
            series: [
              {
                name: "已上架",
                type: "line",
                data: res.data.poolInfo.apool && res.data.poolInfo.apool.active,
              },
              {
                name: "待上架",
                type: "line",
                data:
                  res.data.poolInfo.apool && res.data.poolInfo.apool.pending,
              },
              {
                name: "已禁用",
                type: "line",
                data:
                  res.data.poolInfo.apool && res.data.poolInfo.apool.disabled,
              },
            ],
          };
          this.xpool = {
            title: {
              text: "X号数量",
            },
            tooltip: { trigger: "axis" },
            legend: {
              data: ["使用中", "X池禁用", "号库禁用"],
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: {
              type: "category",
              boundaryGap: false,
              data: res.data.poolInfo.timestampList,
            },
            yAxis: { type: "value" },
            series: [
              {
                name: "使用中",
                type: "line",
                data: res.data.poolInfo.xpool && res.data.poolInfo.xpool.inUse,
              },
              {
                name: "X池禁用",
                type: "line",
                data:
                  res.data.poolInfo.xpool &&
                  res.data.poolInfo.xpool.xpoolDisabled,
              },
              {
                name: "号库禁用",
                type: "line",
                data:
                  res.data.poolInfo.xpool &&
                  res.data.poolInfo.xpool.platformDisabled,
              },
            ],
          };
        });
      })
      .catch((e: any) => {});
  }

  tableEmptyRender = () => {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<>暂无数据</>}
      ></Empty>
    );
  };
}

export default CommonStore;
